<div [class]="'d-flex banner ' + banner().type" [class.minimal]="true" (mouseover)="pause()" (mouseleave)="resume()">
  <div [class]="'icon-wrapper flex-shrink-0 icon-' + banner().type">
    <i
      class="pi"
      [class.pi-check]="banner().type === 'SUCCESS'"
      [class.pi-exclamation-triangle]="banner().type === 'WARNING' || banner().type === 'ERROR'"
      [class.pi-info]="banner().type === 'INFO'"
      aria-hidden="true"
    ></i>
  </div>
  <div class="d-flex flex-column p-2 main-content">
    <div class="d-flex align-items-center gap-2">
      <div [innerHTML]="banner().header | safeHtml" class="fw-bold"></div>
      @if ((banner().count ?? 1) > 1) {
        <span class="fs-xsmall count" [title]="'This happened ' + banner().count + ' times'">×{{ banner().count }}</span>
      }
    </div>
    @if (!!banner().content) {
      <div [innerHTML]="(banner().content ?? '') | safeHtml" class="fs-small content"></div>
    }
    @if (!!banner().detail) {
      <!-- Plain text, never innerHTML: this is a URL, and it is the part a user copies. -->
      <button type="button" class="btn-reset fs-xsmall detail text-start" (click)="copyDetail()" title="Click to copy">
        {{ banner().detail }}
        @if (copied()) {
          <span class="copied">copied</span>
        }
      </button>
    }
  </div>
  <button
    type="button"
    class="btn-reset h-100 center ms-auto align-self-center p-2 text-always-white"
    style="width: 44px"
    (click)="closeBanner.emit()"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
</div>
